/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Form } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { FilterComponentInput } from '@core/offices/types';

import OptionsList from './components/options-list';
import { ExactCheckbox } from './exact-checkbox';

const OptionsWrapper = styled.div`
  .ant-col ant-form-item-label {
    color: var(--secondary) !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    border-color: var(--secondary) !important;
    background-color: var(--secondary) !important;
    ::after {
      border-color: black;
    }
  }

  .ant-checkbox-group-item {
    width: 100%;
    margin-top: 10px;
  }
`;

const Component = (props: FilterComponentInput) => {
  return (
    <OptionsWrapper>
      <Form.Item label={props.filter.label} initialValue={props.value}>
        <div className="w-full max-h-[168px] overflow-auto">
          <OptionsList filter={props.filter} handleChange={props.handleChange} value={props.value} />
        </div>
        <ExactCheckbox filter={props.filter} />
      </Form.Item>
    </OptionsWrapper>
  );
};
export default Component;
